module.exports = __webpack_public_path__ + "static/media/chevron_right_error.26cd5645.svg";


//////////////////
// WEBPACK FOOTER
// ./src/spread/chartOfAccounts/chevron_right_error.svg
// module id = 2204
// module chunks = 0